import View from "../account/views/CreditCardView";
import components from "./components.js";
components.define("js-removeCCcontainer", View);